import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

export const useSystemMaintenance = () => {
  return (
    process.env.REACT_APP_BLOCK_FRONTEND_ACCESS === "true" &&
    dayjs
      .tz(dayjs.utc(), "Europe/Berlin")
      .isAfter(
        dayjs.utc(process.env.REACT_APP_BLOCK_FRONTEND_ACCESS_START_TIME_ISO).tz("Europe/Berlin")
      ) &&
    dayjs
      .tz(dayjs.utc(), "Europe/Berlin")
      .isBefore(
        dayjs.utc(process.env.REACT_APP_BLOCK_FRONTEND_ACCESS_END_TIME_ISO).tz("Europe/Berlin")
      )
  );
};
